import React, { useContext, useState , useEffect } from 'react';
import Context from '../../../../context/context';
import Box from '@mui/material/Box';
import AccountCircle from '@mui/icons-material/AccountCircle';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import PhoneIcon from '@mui/icons-material/Phone';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';

const PassengerDetails = () =>{

    const {state, dispatch} = useContext(Context);
    const [flightNumber, setFlightNumber] = useState(state.selectedOrbit.flightCode);
    const [flightNumberBack, setFlightNumberBack] = useState(state.selectedOrbitBack.flightCode);
    const [name, setName] = useState(state.name);
    const [englishName, setEnglishName] = useState(state.englishName);
    const [amount, setAmount] = useState(state.amount);
    const [phone, setPhone] = useState(state.phone);
    const [anotherPhone, setAnotherPhone] = useState(state.phone);
    const setNameDispatch = data => dispatch({ type: "SET_NAME", payload: data });
    const setEnglishNameDispatch = data => dispatch({ type: "SET_ENGLISH_NAME", payload: data });
    const setFlightNumberDispatch = data => dispatch({ type: "SET_FLIGHT_NUMBER", payload: data });
    const setFlightNumberBackDispatch = data => dispatch({ type: "SET_FLIGHT_NUMBER_BACK", payload: data });
    const setAmountDispatch = data => dispatch({type:"SET_AMOUNT", payload: data});
    const setPhoneDispatch = data => dispatch({type:"SET_PHONE", payload: data});
    const setAnotherPhoneDispatch = data => dispatch({type:"SET_ANOTHER_PHONE", payload: data});
    const setCountryCodeDispatch = data => dispatch({type:"SET_COUNTRY_CODE", payload: data});
    const setSecondCountryCodeDispatch = data => dispatch({type:"SET_SECOND_COUNTRY_CODE", payload: data});

    const countries  = [
        { code: '972', name: 'Israel' },
        { code: '1', name: 'USA' },
        { code: '44', name: 'UK' },
        { code: '380', name: 'Ukraine' },
        { code: '33', name: 'France' },
        { code: '32', name: 'BE' },
      ];

      const [countryCode, setCountryCode] = useState(countries[0].code);
      const [secondCountryCode, setSecondCountryCode] = useState(countries[0].code);
    
      useEffect(()=>{
        setCountryCodeDispatch('+972')
        setSecondCountryCodeDispatch('+972')
        setFlightNumberBackDispatch(state.selectedOrbitBack.flightCode);
        setFlightNumberDispatch(state.selectedOrbit.flightCode);
      } , [])

    const onChangeAmount =(event) => {
      // const inputValue = event.target.value;
      // if(inputValue >= 1){
      // setAmount(event.target.value);
      // setAmountDispatch(event.target.value)
      // }else{
      //   alert("מנימום אחד")
      // }
      setAmount(event.target.value);
      setAmountDispatch(event.target.value)
    }
    const onChangeName = (event) => {
        const inputValue = event.target.value;
        const onlyLetters = /^[א-ת\s]*$/;
      
        if (onlyLetters.test(inputValue)) {
          setName(inputValue);
          setNameDispatch(inputValue);
        } else {
          alert("שם מכיל אותיות בעברית בלבד");
        }
      };
      const onChangeEnglishName = (event) => {
        const inputValue = event.target.value;
        const onlyLetters = /^[A-Za-z\s]*$/;
      
        if (onlyLetters.test(inputValue)) {
          setEnglishName(inputValue);
          setEnglishNameDispatch(inputValue);
        } else {
          alert("שם מכיל אותיות באנגלית בלבד");
        }
      };
      const onChangeFlightNumber = (event) => {
          setFlightNumber(event.target.value);
          setFlightNumberDispatch(event.target.value);
      };
      const onChangeFlightNumberBack = (event) => {
        setFlightNumberBack(event.target.value);
        setFlightNumberBackDispatch(event.target.value);
    };
    const onChangePhone = (event) => {
        const input = event.target.value;
        const phoneRegex = /^[0-9]*$/;
        if (phoneRegex.test(input)) {
          setPhone(input);
          setPhoneDispatch(input);
        }else{
            alert("  מספרים בלבד");  
        }
      };
    const onChangeAnotherPhone = (event) => {
        const input = event.target.value;
        const phoneRegex = /^[0-9]*$/;
        if (phoneRegex.test(input)) {
        setAnotherPhone(input);
        setAnotherPhoneDispatch(input);
        }else{
            alert("  מספרים בלבד");  
        }
    }

    const onChangeCountryCode = (event) => {
      const countryCode = event.target.value;
      setCountryCode(countryCode);
      setCountryCodeDispatch(countryCode);
    };

    const onChangeSecondCountryCode = (event) => {
      const secondcountryCode = event.target.value;
      setSecondCountryCode(secondcountryCode);
      setSecondCountryCodeDispatch(secondcountryCode);
    };

    return (
        <div>
            <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                    <input 
                    placeholder='שם מלא בעברית*'
                    className="invitationInput" 
                    type="text" 
                    value={name} 
                    onChange={onChangeName}  />
                <AccountCircle sx={{ color: 'action.active', mr: 1, my: 1 , fontSize: 45 }} />
            </Box>
            {/* &nbsp;
            <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                    <input 
                    placeholder='שם מלא באנגלית*'
                    className="invitationInput" 
                    type="text" 
                    value={englishName} 
                    onChange={onChangeEnglishName}  />
                <AccountCircle sx={{ color: 'action.active', mr: 1, my: 1 , fontSize: 45 }} />
            </Box> */}
            &nbsp;
            <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
      <select 
       style={{width:'100px' , height:'45px' ,marginBottom:'6px' , border:'none' , borderBottom:'2px solid black' }}
        onChange={onChangeCountryCode} value={countryCode}>
        {countries.map((country) => (
          <option key={country.code} value={country.code}>
             +{country.code} {country.name}
          </option>
        ))}
      </select>
      <input
        required
        placeholder='טלפון נייד / עדיפות עם וואצפ*'
        className="invitationInput invitationInputPhone"
        type="text"
        value={phone}
        onChange={onChangePhone}
      />
      <PhoneIcon sx={{ color: 'action.active', mr: 1, my: 1, fontSize: 45 }} />
    </Box>
            &nbsp;
            <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
            <select 
       style={{width:'100px' , height:'45px' ,marginBottom:'6px' , border:'none' , borderBottom:'2px solid black' }}
       onChange={onChangeSecondCountryCode} value={secondCountryCode}>
        {countries.map((country) => (
          <option key={country.code} value={country.code}>
            +{country.code} {country.name}
          </option>
        ))}
      </select>
                     <input 
                    required
                    placeholder="טלפון זמין בחול ( אופציונלי )"
                    className="invitationInput invitationInputPhone" 
                    type="text" 
                    value={anotherPhone}
                    onChange={onChangeAnotherPhone}  />
                <PhoneIcon sx={{ color: 'action.active', mr: 1, my: 1 , fontSize: 45 }} />
            </Box>
            &nbsp;
            {state.side === 'לאומן' ? <>
            <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                    <input 
                    inputprops={{ inputMode: 'numeric', pattern: '[0-9]*', min: 1 }}
                    placeholder='מספר טיסה*'
                    className="invitationInput" 
                    type="text" 
                    value={flightNumber} 
                    min={1}
                    onChange={onChangeFlightNumber}  />
                <FlightTakeoffIcon sx={{ color: 'action.active', mr: 1, my: 1 , fontSize: 45 }} />
            </Box>
            </> : <></>}
            {/* {state.selectedOrbitBack ? <>
            <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                    <input 
                    inputprops={{ inputMode: 'numeric', pattern: '[0-9]*', min: 1 }}
                    placeholder='מספר טיסה חזור *'
                    className="invitationInput" 
                    type="text" 
                    value={flightNumberBack} 
                    min={1}
                    onChange={onChangeFlightNumberBack}  />
                <FlightTakeoffIcon sx={{ color: 'action.active', mr: 1, my: 1 , fontSize: 45 }} />
            </Box>
            </> : <></>} */}
           
            &nbsp;
            <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                    <input
                    inputprops={{ inputMode: 'numeric', pattern: '[0-9]*', min: 1 , max: 10 }} 
                    placeholder='כמות*'
                    className="invitationInput" 
                    type="number" 
                    value={amount} 
                    min={1}
                    max={10}
                    onChange={onChangeAmount}  />
                <PeopleAltIcon sx={{ color: 'action.active', mr: 1, my: 1 , fontSize: 45 }} />
                &nbsp;
            </Box>
        </div> 
    )
}

export default PassengerDetails;